/**
 * Role hierarchy - lower number = higher privilege.
 * Must match CenterReach.Domain.Enums.SystemRole.
 */
const ROLE_LEVEL: Record<string, number> = {
    SuperAdmin: 0,
    RiksAdmin: 1,
    DistriktAdmin: 2,
    KretsAdmin: 3,
    AvdelningAdmin: 4,
    Distributor: 5
};

export function getRoleLevel(role: string): number {
    return ROLE_LEVEL[role] ?? 999;
}

/**
 * Returns true if `assignableRole` can be assigned by a user with `assignerHighestRole`.
 * A user can only assign roles that are same or lower (higher or equal level number).
 */
export function canAssignRole(
    assignerHighestRole: string,
    assignableRole: string
): boolean {
    const assignerLevel = getRoleLevel(assignerHighestRole);
    const assignableLevel = getRoleLevel(assignableRole);
    return assignableLevel >= assignerLevel;
}

/**
 * Filter roles to only those the current user can assign (same or lower privilege).
 */
export function filterAssignableRoles(
    roles: { value: string; name: string }[],
    currentUserHighestRole: string
): { value: string; name: string }[] {
    return roles.filter((r) => canAssignRole(currentUserHighestRole, r.value));
}

/**
 * Get the highest (most privileged) role from a list of role names.
 */
export function getHighestRole(roleNames: string[]): string | null {
    if (roleNames.length === 0) return null;
    return roleNames.reduce((highest, role) =>
        getRoleLevel(role) < getRoleLevel(highest) ? role : highest
    );
}
